import {
  ACTIVITE_CONTENT_TYPE_VIDEO,
  ACTIVITE_CONTENT_TYPE_FORM,
  ACTIVITE_CONTENT_TYPE_GAME,
  ACTIVITE_CONTENT_TYPE_ORAL,
} from '@inspire/data/static/activites';
import InfoIcon from '@inspire/ui/assets/undraw/information.svg';
import ComprendreParcoursupIcon from '@inspire/ui/assets/undraw/remote.svg';
import ConnaitreEntrepriseIcon from '@inspire/ui/assets/undraw/building.svg';
import MetiersIcon from '@inspire/ui/assets/undraw/mirror.svg';
import ApprentissageIcon from '@inspire/ui/assets/undraw/apprentissage.svg';
import CompetencesAcquisesIcon from '@inspire/ui/assets/undraw/progress.svg';
import MondeProIcon from '@inspire/ui/assets/undraw/prep.svg';
import DebatIcon from '@inspire/ui/assets/undraw/debate.svg';
//import DefinirProjetIcon from '@inspire/ui/assets/undraw/search2.svg';
import {
  FormatDEnseignement,
  FormationsAlternance,
  TypeDEnseignement,
  FormationsParcoursup,
  DureeFormations,
  FormationsLieu,
  LaBonneDefinition,
  LicencesGenOuPro,
} from 'components/activites/premiere/sinformer-etudes-sup/principales-formations-post-bac';
import {
  PhotoLanguage,
  TrierLogementsEtudiants,
  VieEtudiante,
  Crous,
} from 'components/activites/premiere/sinformer-etudes-sup/VieEtudiante';
import {
  EtapesOrientation,
  GererMonProjet,
  InfographieParcoursup,
} from 'components/activites/premiere/comprendre-parcoursup/temps-orientation';
import {
  OrganigrammeEntreprise,
  QuizzEntreprise,
  TemoignagesPro,
  VideoDecouvrirEntreprise,
} from 'components/activites/premiere/connaitre-lentreprise/decouvrir-lentreprise';
import {
  AlternancesQuestionsOrales,
  ApprofondirNotionAlternance,
  DebatAlternance,
} from 'components/activites/premiere/decouvrir-alternance-et-apprentissage/point-alternance';
import {
  DefinitionSoftSkills,
  DecrisExperienceSoftSkills,
  SelectSoftSkills,
  SelectDifficultesSoftSkills,
  DecrisActionsSoftSkills,
  DecrisAmeliorationsSoftSkills,
  SelectRessentiSoftSkills,
  MyRecapSoftSkills,
  PlanActionObjectif,
  PlanActionEntreprendre,
  PlanActionTemps,
  MyRecapPlanAction,
  IdentifierSoftSkills,
} from 'components/activites/premiere/connaitre-mes-competences-acquises/mieux-se-connaitre';
import {
  CommunicationNonVerbale,
  ListCompetences,
  MyRecapCompetences,
  RappelCompetences,
  SimulationEntretien,
  SimulationEntretienFeedback,
} from 'components/activites/premiere/preparer-entretiens/atelier-code-pro';
import {
  DefinitionApprentissage,
  InfographieChiffresApprentissage,
  InfographieEtapesAlternance,
  LesEtapesAvantApprentissage,
  TemoignageEric,
  TemoignageNaomi,
  TemoignagePaolandrea,
} from 'components/activites/premiere/decouvrir-alternance-et-apprentissage/alternance-voie-porteuse';
import { QuiSuisJeEtudesSuperieurs } from 'components/activites/premiere/sinformer-etudes-sup/QuiSuisJeEtudesSuperieurs';
import VideoDecouverteMetiers from 'components/activites/premiere/decouvrir-des-metiers/VideosDecouverteMetiers';
import {
  InfographieConseilEntretien,
  TemoignagesAnecdotes,
  TémoignagesProRH,
} from 'components/activites/premiere/preparer-entretiens/conseils-entretien';
import { ParcoursLineaire } from 'components/activites/premiere/connaitre-mes-competences-acquises/ParcoursLineaire';
import { BeneficesAlternance } from 'components/activites/premiere/connaitre-mes-competences-acquises/BeneficesAlternance';
import FichesMetiers from 'components/activites/premiere/decouvrir-des-metiers/FichesMetiers';
import { makeBilanActivite } from 'lib/activites';
import { ModuleType } from 'types';
import RechercheStageIcon from '@inspire/ui/assets/undraw/job_hunt.svg';
import {
  PreparerRechercheDeStage,
  QCMRechercheDeStage,
  QuestionsRechercheDeStage,
  VideoRechercheDeStage,
} from 'components/activites/seconde/rechercher-son-stage-et-postuler/rechercher-sur-internet';
import {
  ChecklistCV,
  QuizzCV,
} from 'components/activites/seconde/rechercher-son-stage-et-postuler/cv';
import {
  ChecklistLM,
  QuizzLM,
} from 'components/activites/seconde/rechercher-son-stage-et-postuler/lm';
/*
import { Introduction } from 'components/activites/premiere/definir-mon-projet-dorientation/Introduction';
import { MesExperiences } from 'components/activites/premiere/definir-mon-projet-dorientation/MesExperiences';
import { CapacitesSociales } from 'components/activites/premiere/definir-mon-projet-dorientation/CapacitesSociales';
import { MesValeurs } from 'components/activites/premiere/definir-mon-projet-dorientation/MesValeurs';
import { MesQuestionnements } from 'components/activites/premiere/definir-mon-projet-dorientation/MesQuestionnements';
import { CapacitesPersonnelles } from 'components/activites/premiere/definir-mon-projet-dorientation/CapacitesPersonnelles';
import { CapacitesMethodologiques } from 'components/activites/premiere/definir-mon-projet-dorientation/CapacitesMethodologiques';
import { CapacitesSocialesADevelopper } from 'components/activites/premiere/definir-mon-projet-dorientation/CapacitesSocialesADevelopper';
import { capacitesPersonnellesADevelopper } from 'components/activites/premiere/definir-mon-projet-dorientation/CapacitesPersonnellesADevelopper';
import { CapacitesMethodologiquesADevelopper } from 'components/activites/premiere/definir-mon-projet-dorientation/CapacitesMethodologiquesADevelopper';
import { MesMotivations } from 'components/activites/premiere/definir-mon-projet-dorientation/MesMotivations';
import { SurmonterMesCraintes } from 'components/activites/premiere/definir-mon-projet-dorientation/SurmonterMesCraintes';
import { MesForcesEtAspirations } from 'components/activites/premiere/definir-mon-projet-dorientation/MesForcesEtAspirations';
import { SecteursEtCompetences } from 'components/activites/premiere/definir-mon-projet-dorientation/SecteursEtCompetences';
import { ComparerFormations } from 'components/activites/premiere/definir-mon-projet-dorientation/ComparerFormations';
import { TableauComparaisonFormations } from 'components/activites/premiere/definir-mon-projet-dorientation/TableauComparaisonFormations';
import { ComparerFormationsMesChoix } from 'components/activites/premiere/definir-mon-projet-dorientation/ComparerFormationsMesChoix';
import { MeRenseignerSurMaFormation } from 'components/activites/premiere/definir-mon-projet-dorientation/MeResenseignerSurMaFormation';
import { MePreparerALaVieEtudiante } from 'components/activites/premiere/definir-mon-projet-dorientation/MePreparerALaVieEtudiante';
*/

export const DECOUVRIR_PISTES_AVENIR_ID = 'decouvrir-pistes-davenir';
const SINFORMER_ETUDES_SUP_ID = 'sinformer-etudes-sup';
const COMPRENDRE_PARCOURSUP_ID = 'comprendre-parcoursup';
const CONNAITRE_ENTREPRISE_ID = 'connaitre-lentreprise';
export const DECOUVRIR_METIERS_ID = 'decouvrir-des-metiers';
const DECOUVRIR_ALTERNANCE_APPRENTISSAGE_ID =
  'decouvrir-alternance-et-apprentissage';
const CONNAITRE_MES_COMPETENCES_ACQUISES_ID =
  'connaitre-mes-competences-acquises';
const PREPARER_ENTRETIENS_ID = 'preparer-entretiens';
const RECHERCHER_STAGE_POSTULER_ID = 'rechercher-son-stage-et-postuler';
/*
const DEFINIR_PROJET_ORIENTATION_ID = 'definir-mon-projet-dorientation';

const hasFinishedActivite = (activiteId) => {
  return {
    condition: ({ myBacProActivites }) =>
      myBacProActivites?.find(
        (a) => a.activiteId === activiteId && a.status === 'completed'
      ),
    reason:
      "Pour commencer cette activité, tu dois d'abord réaliser l'activité précédente.",
    profReason:
      "Pour commencer cette activité, vos élèves doivent d'abord réaliser l'activité précédente.",
  };
};
*/

const modules: ModuleType[] = [
  /*
  {
    theme: 'etudes-sup',
    moduleId: DEFINIR_PROJET_ORIENTATION_ID,
    title: 'Définir mon projet d’orientation',
    icon: DefinirProjetIcon,
    intro:
      'Ce module t’aidera à identifier les secteurs professionnels et les formations qui y mènent les mieux adaptées à ton profil. À chaque étape de l’enquête, réponds aux questions en t’aidant des ressources mises à ta disposition. Les étapes sont à réaliser dans l’ordre. A la fin de chaque étape, tu devras valider tes réponses pour passer à l’étape suivante.',
    profDescription:
      "Ce module vous aidera à accompagner le travail de réflexion autour de l’orientation en favorisant l’auto-analyse du profil et des craintes des élèves pour qu’ils puissent mieux définir leurs projets d’orientation. Ce module peut être programmé sur plusieurs séances, et est à faire dans l’ordre. A la fin, l’élève aura un récapitulatif de ses réponses, et vous aurez accès aux informations notées par l'élève.",
    isMandatory: false,
    activites: [
      {
        title: 'Je fais le bilan',
        activiteId: 'je-fais-le-bilan-pour-mon-orientation',
        description:
          'Cette étape te permet de faire un point sur tes expériences, tes motivations et tes doutes, en identifiant tes valeurs pour t’aider à définir ton projet d’orientation.',
        profDescription:
          'L’élève fait un bilan de ses expériences et fait des recherches pour lever les freins qu’il peut avoir. Il identifie ses valeurs et motivations à la poursuite d’études.',
        contentInfo: [
          { type: ACTIVITE_CONTENT_TYPE_FORM },
          { type: ACTIVITE_CONTENT_TYPE_GAME },
        ],
        duration: 20,
        steps: [
          {
            title: 'Qu’entend-t-on par “projet d’orientation” ?',
            component: Introduction,
          },
          {
            title: 'Mes expériences',
            component: MesExperiences,
            hasOwnFooter: true,
          },
          {
            title: 'Capacités sociales 1/2',
            component: CapacitesSociales,
            hasOwnFooter: true,
          },
          {
            title: 'Capacités personnelles 1/2',
            component: CapacitesPersonnelles,
            hasOwnFooter: true,
          },
          {
            title: 'Capacités méthodologiques 1/2',
            component: CapacitesMethodologiques,
            hasOwnFooter: true,
          },
          {
            title: 'Capacités sociales 2/2',
            component: CapacitesSocialesADevelopper,
            hasOwnFooter: true,
          },
          {
            title: 'Capacités personnelles 2/2',
            component: capacitesPersonnellesADevelopper,
            hasOwnFooter: true,
          },
          {
            title: 'Capacités méthodologiques 2/2',
            component: CapacitesMethodologiquesADevelopper,
            hasOwnFooter: true,
          },
          {
            title: 'Mes motivations',
            component: MesMotivations,
            hasOwnFooter: true,
          },
          {
            title: 'Mes valeurs',
            component: MesValeurs,
            hasOwnFooter: true,
          },
          {
            title: 'Mes questionnements',
            component: MesQuestionnements,
            hasOwnFooter: true,
          },
          {
            title: 'Surmonter mes craintes',
            component: SurmonterMesCraintes,
            hasOwnFooter: true,
          },
        ],
      },
      {
        title: 'Je définis mon projet',
        activiteId: 'je-definis-mon-projet',
        description:
          'Cette étape te permet d’identifier tes compétences transversales à développer,  en fonction des secteurs professionnels qui t’intéressent, mais aussi de ton profil (centres d’intérêts, capacités, envies).',
        profDescription:
          'L’élève commence à définir son projet en mettant en lien ses valeurs, ses envies, ses compétences. Il met en perspective son projet avec des secteurs professionnels.',
        contentInfo: [{ type: ACTIVITE_CONTENT_TYPE_FORM }],
        duration: 25,
        requirements: [
          hasFinishedActivite('je-fais-le-bilan-pour-mon-orientation'),
        ],
        steps: [
          {
            title: 'Mes forces et aspirations',
            component: MesForcesEtAspirations,
            hasOwnFooter: true,
          },
          {
            title: 'Secteur et compétences',
            component: SecteursEtCompetences,
            hasOwnFooter: true,
          },
        ],
      },
      {
        title: 'Je détaille mon projet',
        activiteId: 'je-detaille-mon-projet',
        description:
          'Cette étape te permet poursuivre tes recherches en te concentrant sur trois formations, identifier des débouchés, et hiérarchiser tes choix selon tes critères.',
        profDescription:
          'L’élève poursuit en comparant des pistes de formations recommandées, et les hiérarchisent en fonction de ses critères.',
        contentInfo: [
          { type: ACTIVITE_CONTENT_TYPE_FORM },
          { type: ACTIVITE_CONTENT_TYPE_GAME },
        ],
        duration: 25,
        requirements: [hasFinishedActivite('je-definis-mon-projet')],
        steps: [
          {
            title: 'Comparer les formations',
            component: ComparerFormations,
            hasOwnFooter: true,
          },
          {
            title: 'Tableau de comparaison',
            component: TableauComparaisonFormations,
          },
          {
            title: 'Mes choix',
            component: ComparerFormationsMesChoix,
            hasOwnFooter: true,
          },
        ],
      },
      {
        title: 'Je confirme mon projet',
        activiteId: 'je-confirme-mon-projet',
        description:
          'Cette étape te permet de commencer à t’informer sur les conditions d’admission d’une formation qui t’intéresse, et d’identifier tes points forts et axes d’amélioration pour ton projet d’orientation.',
        profDescription:
          'L’élève s’exerce à se renseigner sur une formation qu’il envisage, identifie ses points forts et axes d’amélioration, et se renseigne sur le coût des études.',
        contentInfo: [
          { type: ACTIVITE_CONTENT_TYPE_FORM },
          { type: ACTIVITE_CONTENT_TYPE_GAME },
        ],
        duration: 15,
        requirements: [hasFinishedActivite('je-detaille-mon-projet')],
        steps: [
          {
            title: 'Me renseigner sur ma formation',
            component: MeRenseignerSurMaFormation,
            hasOwnFooter: true,
          },
          {
            title: 'Me préparer à la vie étudiante',
            component: MePreparerALaVieEtudiante,
            hasOwnFooter: true,
          },
        ],
      },
      makeBilanActivite(DEFINIR_PROJET_ORIENTATION_ID, {
        requirements: [hasFinishedActivite('je-confirme-mon-projet')],
        downloadPdf: true,
        showContactEclaireurs: true,
      }),
    ],
    bilanQuestions: [
      {
        id: 'utile-pour-affiner-mon-projet',
        text: "Ce module a-t-il été utile pour affiner mon projet d'orientation post-bac ?",
      },
      {
        id: 'module-interessant',
        text: 'Ce module était-il intéressant ?',
      },
      {
        id: 'appris-des-choses-sur-moi',
        text: 'J’ai appris des choses sur moi.',
      },
      {
        id: 'appris-des-choses-sur-les-formations',
        text: 'J’ai appris des choses sur les formations post-bac.',
      },
    ],
  },
  {
    theme: 'etudes-sup',
    moduleId: DECOUVRIR_PISTES_AVENIR_ID,
    title: '!!! Découvrir des pistes d’avenir',
    icon: QuestionnaireIcon,
    intro:
      "Après avoir répondu au questionnaire, tu découvriras des pistes d'avenir potentielles adaptées à ton parcours personnel.",
    profDescription:
      'Les élèves remplissent un questionnaire qui leur permettra d’avoir des pistes d’avenir personnalisées afin de leur montrer les possibilités qui s’offrent à eux par rapport à leur profil que soit la poursuite d’études après le bac ou l’insertion professionnelle. Vous aurez accès aux réponses fournies par vos élèves.',
    objectifPedagogique:
      'En ayant des pistes d’avenir proposées en adéquation avec les réponses au questionnaire, les élèves pourront prioriser leurs prises d’informations sur les pistes les plus susceptibles de leur correspondre.',
    isMandatory: true,
    activites: [
      {
        title: 'Mon questionnaire',
        activiteId: 'mon-questionnaire',
        duration: 20,
        profDescription:
          'L’activité a pour but de fournir aux lycéens, une fois le questionnaire rempli, une liste de pistes potentielles vers lesquelles ces derniers peuvent s’orienter. Ces pistes se déclinent sous forme de contenus informatifs traitant d’études supérieures ou d’insertion professionnelle.',
        description:
          "Une fois le questionnaire complété, tu découvriras les pistes d'avenir potentielles qui te seront proposées en fonction de tes réponses.",
        contentInfo: [{ type: ACTIVITE_CONTENT_TYPE_FORM }],
        steps: [
          { title: 'On va commencer !', component: IntroQuestionnaire },
          {
            title: 'Poursuite des études',
            component: PrevisionPostBac,
            hasOwnFooter: true,
          },
          {
            title: 'Lieu de vie et trajet',
            component: LieuDeVie,
            hasOwnFooter: true,
          },
          {
            title: 'Situation financière',
            component: Finances,
            hasOwnFooter: true,
          },
          { title: 'Débouchés', component: Debouches, hasOwnFooter: true },
          { title: 'On continue !', component: Continue, hasOwnFooter: true },
          { title: 'Tout va bien ?', component: Encouragement },
          {
            title: 'Avenir professionnel 1/2',
            component: AvenirProfessionnel1,
            hasOwnFooter: true,
          },
          {
            title: 'Avenir professionnel 2/2',
            component: AvenirProfessionnel2,
            hasOwnFooter: true,
          },
          { title: 'Qualités', component: Qualites, hasOwnFooter: true },
          {
            title: 'Matières',
            component: MatieresTroncCommun,
            hasOwnFooter: true,
          },
          { title: 'Matières', component: MatieresSpes, hasOwnFooter: true },
          { title: 'Études', component: Etudes, hasOwnFooter: true },
          {
            title: 'Attitude en classe',
            component: Attitude,
            hasOwnFooter: true,
          },
        ],
      },
      {
        title: 'Mes pistes recommandées',
        activiteId: 'mes-pistes-recommandees',
        duration: 20,
        description:
          'Cette activité te permet de découvrir des pistes d’avenir qui te sont proposées à la suite de tes réponses au questionnaire d’aide à l’orientation.',
        profDescription:
          'Cette activité permet aux lycéens de s’informer sur les pistes d’avenir qui leur ont été recommandées après avoir rempli leur questionnaire d’orientation.',
        objectifPedagogique:
          'L’objectif de ce module est de présenter quelques pistes d’avenir, de réfléchir autour de ces propositions et voir si celles-ci sont conformes ou pas à ce que les lycéens envisagent actuellement.',
        // requirements: [hasFinishedQuestionnaire],
        contentInfo: [{ type: ACTIVITE_CONTENT_TYPE_FORM }],
        steps: [
          {
            title: 'Découverte des pistes',
            component: AlgoProgress,
            hasOwnFooter: true,
          },
          {
            title: 'Découverte des pistes',
            component: DecouvertePisteConsignes,
            hasOwnFooter: true,
          },
          {
            title: 'Découverte des pistes',
            component: PisteRecoForm,
            hasOwnFooter: true,
          },
          {
            title: 'Découverte des pistes',
            component: DecouvertePisteConclusion,
          },
        ],
      },
      makeBilanActivite(DECOUVRIR_PISTES_AVENIR_ID),
    ],
    bilanQuestions: [
      {
        id: 'citer-une-piste-avenir',
        text: "Je peux citer une piste d'avenir qui m'intéresse.",
      },
      {
        id: 'citer-avantages-inconvenients-piste',
        text: 'Je peux citer les avantages et inconvénients de cette piste.',
      },
    ],
  },
  */
  {
    theme: 'etudes-sup',
    moduleId: SINFORMER_ETUDES_SUP_ID,
    title: 'S’informer et se préparer aux études supérieures',
    icon: InfoIcon,
    intro:
      'Ce module te permettra de te projeter dans les études supérieures et la vie étudiante.',
    profDescription:
      'Ce module a pour but de découvrir les principales formations post-bac et leur fonctionnement, ainsi que de permettre aux élèves de commencer à se projeter dans les études supérieures.',
    objectifPedagogique:
      'Permettre aux élèves de tester et d’enrichir leurs connaissances des principales formations post-bac et de la vie étudiante.',
    // requirements: [hasFinishedQuestionnaire],
    activites: [
      {
        title: 'Les principales formations post-bac',
        activiteId: 'principales-formations-post-bac',
        duration: 20,
        profDescription:
          'L’activité a pour but de présenter les informations clés des principales filières post-bac : durée, type d’encadrement, lieu de formation, type d’enseignements.',
        description:
          'Cette activité te permettra de découvrir les principales filières post-bac et d’avoir des informations sur leur durée, le type d’encadrement ou encore les lieux de formation.',
        contentInfo: [{ type: ACTIVITE_CONTENT_TYPE_GAME }],
        steps: [
          {
            title: 'La bonne définition',
            component: LaBonneDefinition,
          },
          {
            title: 'Les formations et leur lieu d’étude',
            component: FormationsLieu,
          },
          {
            title: 'Durée des formations',
            component: DureeFormations,
          },
          {
            title: "Format d'enseignement",
            component: FormatDEnseignement,
          },
          {
            title: "Type d'encadrement d'enseignement",
            component: TypeDEnseignement,
          },
          {
            title: 'Formations en alternance',
            component: FormationsAlternance,
          },
          {
            title: 'Formations via Parcoursup',
            component: FormationsParcoursup,
          },
          {
            title: 'Licence générale ou professionnelle ?',
            component: LicencesGenOuPro,
          },
        ],
      },
      {
        title: 'Le qui suis-je des études supérieures',
        activiteId: 'qui-suis-je-etudes-superieures',
        duration: 10,
        profDescription:
          'A travers un quiz, les élèves testent leurs connaissances sur les études supérieures en s’aidant d’une infographie.',
        description:
          'Cette activité te permettra de tester tes connaissances sur les études supérieures.',
        component: QuiSuisJeEtudesSuperieurs,
        contentInfo: [{ type: ACTIVITE_CONTENT_TYPE_GAME }],
      },
      {
        title: 'La vie étudiante',
        activiteId: 'la-vie-etudiante',
        duration: 15,
        profDescription:
          'Cette activité permet aux lycéens d’identifier les dépenses courantes d’un étudiant et les aides existantes.',
        description:
          'Cette activité te permettra de mieux te projeter dans la vie étudiante en identifiant les dépenses typiques d’un étudiant et les aides auxquelles il peut avoir droit.',
        contentInfo: [
          { type: ACTIVITE_CONTENT_TYPE_ORAL },
          { type: ACTIVITE_CONTENT_TYPE_GAME },
        ],
        steps: [
          {
            title: 'Photolangage des étudiants',
            component: PhotoLanguage,
            profInstructions:
              'Exemples de dépenses : Frais de scolarité, Nourriture, Transport, Logement, Abonnements (internet, téléphone, électricité, etc.), Santé, Loisirs, Matériels scolaires.',
          },
          {
            title: 'Les logements pour étudiants',
            component: VieEtudiante,
            profInstructions:
              'Demandez aux élèves de donner des exemples de types de logement pour les étudiants. Exemples de réponses : Famille, Logement en résidence étudiante universitaire, Logement intergénérationnel, Colocation, Studio...',
          },
          {
            title: 'Trier les logements du - cher au + cher',
            component: TrierLogementsEtudiants,
            profInstructions:
              'Demandez aux élèves de trier ces logements du moins cher au plus cher et d’indiquer des tarifs approximatifs en fonction de leur région.',
          },
          {
            title: 'CROUS',
            component: Crous,
          },
        ],
      },
      makeBilanActivite(SINFORMER_ETUDES_SUP_ID),
    ],
    bilanQuestions: [
      {
        id: 'citer-principales-formations',
        text: 'Je peux citer les principales formations possibles après un bac.',
      },
      {
        id: 'citer-principales-depenses',
        text: "Je peux citer les principales dépenses d'un étudiant.",
      },
      {
        id: 'citer-aides',
        text: 'Je peux citer des aides auxquelles les étudiants peuvent avoir droit.',
      },
      {
        id: 'citer-exemples-logements',
        text: 'Je peux donner des exemples de logements possibles pour les étudiants.',
      },
    ],
  },
  {
    theme: 'etudes-sup',
    moduleId: COMPRENDRE_PARCOURSUP_ID,
    title: 'Les grandes étapes de Parcoursup',
    icon: ComprendreParcoursupIcon,
    intro:
      'Ce module te permettra de découvrir les grandes étapes de Parcoursup et d’apprendre à gérer ton temps pour construire ton projet d’orientation.',
    profDescription:
      'Ce module est une introduction à l’univers Parcoursup et permet aux lycéens de commencer à se familiariser avec les grandes étapes de l’orientation.',
    objectifPedagogique:
      'Avec ce module, les élèves prennent conscience qu’un projet d’orientation se construit pas à pas et dans le temps. Qu’il y a des temps de recherche d’informations et de réflexion, et des temps de prise de décision.',
    // requirements: [hasFinishedQuestionnaire],
    activites: [
      {
        title: 'Les grandes étapes Parcoursup',
        activiteId: 'grandes-etapes-parcoursup',
        profDescription:
          'Cette activité propose aux élèves de prendre connaissance des principales étapes sur Parcoursup pour mieux les aider à gérer leur projet d’orientation dans le temps.',
        description:
          'Cette activité te propose de découvrir les principales étapes pour construire tes choix d’orientation sur Parcoursup.',
        duration: 20,
        contentInfo: [{ type: ACTIVITE_CONTENT_TYPE_GAME }],
        steps: [
          {
            title: "Gérer mon projet d'orientation dans le temps",
            component: GererMonProjet,
            hasOwnFooter: true,
          },
          {
            title: "Etapes de l'orientation",
            component: EtapesOrientation,
          },
          {
            title: 'Infographie Parcoursup',
            component: InfographieParcoursup,
          },
        ],
      },
      makeBilanActivite(COMPRENDRE_PARCOURSUP_ID),
    ],
    bilanQuestions: [
      {
        id: 'citer-etapes-parcoursup',
        text: 'Je peux citer les grandes étapes de Parcoursup',
      },
      {
        id: 'idee-prochaines-etapes-formation',
        text: "J'ai une idée des prochaines étapes pour commencer à préparer mes choix de formations.",
      },
    ],
  },
  {
    theme: 'insertion-pro',
    moduleId: CONNAITRE_ENTREPRISE_ID,
    icon: ConnaitreEntrepriseIcon,
    title: 'Connaître l’entreprise et son organisation',
    intro:
      'Ce module te permettra de mieux connaître le monde de l’entreprise et son organisation.',
    profDescription:
      'Ce module permet aux lycéens de mieux connaître le monde de l’entreprise.',
    objectifPedagogique:
      'Les élèves pourront tester leurs connaissances sur les entreprises, leur fonctionnement et leur organisation.',
    activites: [
      {
        title: 'Je découvre l’entreprise',
        activiteId: 'decouvrir-lentreprise',
        duration: 40,
        profDescription:
          'L’activité a pour but de faire découvrir les entreprises aux élèves ainsi que leur mode de fonctionnement.',
        description:
          'Cette activité te permettra de découvrir le monde de l’entreprise de l’intérieur et de comprendre son organisation.',
        contentInfo: [
          { type: ACTIVITE_CONTENT_TYPE_VIDEO },
          { type: ACTIVITE_CONTENT_TYPE_GAME },
        ],
        steps: [
          {
            title: 'Quiz',
            component: QuizzEntreprise,
          },
          {
            title: 'Qu’est-ce qu’une entreprise ?',
            component: VideoDecouvrirEntreprise,
          },
          {
            title: 'Organigramme',
            component: OrganigrammeEntreprise,
          },
          {
            title: 'Témoignages de professionnels',
            component: TemoignagesPro,
          },
        ],
      },
      makeBilanActivite(CONNAITRE_ENTREPRISE_ID),
    ],
    bilanQuestions: [
      {
        id: 'citer-types-entreprises',
        text: "Je peux citer différents types d'entreprises.",
      },
      {
        id: 'citer-fonctions-entreprise',
        text: "Je peux citer les fonctions principales d'une entreprise.",
      },
    ],
    // requirements: [hasFinishedQuestionnaire],
  },
  {
    theme: 'insertion-pro',
    moduleId: DECOUVRIR_METIERS_ID,
    title: 'Découvrir des métiers',
    icon: MetiersIcon,
    intro:
      "Ce module te permettra d'approfondir tes connaissances sur certains métiers en lien avec ton secteur de formation.",
    profDescription:
      'Ce module permet aux lycéens de mieux connaître certains métiers en lien avec leur secteur de formation.',
    objectifPedagogique:
      'À travers ce module les élèves découvriront des métiers et apprendront à identifier les informations pertinentes sur ces métiers (missions, profils souhaités, compétences requises,...)',
    activites: [
      {
        title: "Je m'informe sur les métiers",
        activiteId: 'information-metiers',
        duration: 20,
        profDescription:
          'L’activité permettra de comprendre et identifier des métiers correspondants au secteur d’études dans lequel se situe l’élève.',
        description:
          'Découvrir des métiers présentés par des professionnels en activité.',
        contentInfo: [
          { type: ACTIVITE_CONTENT_TYPE_VIDEO },
          { type: ACTIVITE_CONTENT_TYPE_ORAL },
        ],
        steps: [
          {
            title: 'Vidéos témoignages',
            component: VideoDecouverteMetiers,
          },
          {
            title: 'Fiches métiers',
            component: FichesMetiers,
          },
        ],
      },
      makeBilanActivite(DECOUVRIR_METIERS_ID),
    ],
    bilanQuestions: [
      {
        id: 'decrire-missions-metier',
        text: 'Je peux décrire les missions principales du métier analysé durant ce module.',
      },
      {
        id: 'citer-competences-demandees-metier',
        text: 'Je peux citer les compétences demandées dans le métier analysé durant ce module.',
      },
    ],
    // requirements: [hasFinishedQuestionnaire],
  },
  {
    theme: 'insertion-pro',
    moduleId: DECOUVRIR_ALTERNANCE_APPRENTISSAGE_ID,
    title: "Découvrir l'alternance et l'apprentissage",
    icon: ApprentissageIcon,
    intro:
      "Ce module te permettra d'approfondir tes connaissances sur l'alternance.",
    profDescription:
      "Ce module permet aux élèves de découvrir la notion d’alternance et d'approfondir leurs connaissances sur ce type de formation. ",
    objectifPedagogique:
      'L’objectif de ce module est de mieux appréhender l’univers de l’alternance et de faire la distinction entre alternance et apprentissage.',
    activites: [
      {
        title: "Le point sur l'alternance",
        activiteId: 'point-alternance',
        duration: 15,
        profDescription:
          'A travers une infographie et un débat, vous accompagnerez les élèves à mieux comprendre l’alternance et à déconstruire les idées reçues.',
        description:
          'Avec cette activité, tu découvriras plus en profondeur ce qu’est l’alternance.',
        contentInfo: [
          { type: ACTIVITE_CONTENT_TYPE_ORAL },
          { type: ACTIVITE_CONTENT_TYPE_GAME },
        ],
        steps: [
          {
            title: 'Approfondir la notion d’alternance',
            component: ApprofondirNotionAlternance,
            profInstructions:
              "Pour mieux comprendre les réponses du quiz, les élèves poursuivent l'exercice en recherchant les informations sur l’alternance à l’aide de l’infographie.",
          },
          {
            title: "Approfondir la notion d'alternance",
            component: AlternancesQuestionsOrales,
          },
        ],
      },
      {
        title: "Les avantages de l'apprentissage",
        activiteId: 'avantages-apprentissage',
        duration: 45,
        profDescription:
          'A travers des témoignages vidéos et une infographie, les élèves découvriront les avantages de l’alternance.',
        description:
          'Avec cette activité et à travers des témoignages, tu découvriras les avantages de faire une formation en alternance.',
        contentInfo: [
          { type: ACTIVITE_CONTENT_TYPE_VIDEO },
          { type: ACTIVITE_CONTENT_TYPE_GAME },
        ],
        steps: [
          {
            title: "Définition de l'apprentissage",
            component: DefinitionApprentissage,
          },
          {
            title: 'Vidéos témoignages d’apprentis',
            component: TemoignageNaomi,
          },
          {
            title: 'Vidéos témoignages d’apprentis',
            component: TemoignageEric,
          },
          {
            title: 'Vidéos témoignages d’apprentis',
            component: TemoignagePaolandrea,
          },
          {
            title: 'Infographie sur les chiffres clés de l’apprentissage',
            component: InfographieChiffresApprentissage,
          },
          {
            title: 'Les étapes avant d’entrer en apprentissage',
            component: LesEtapesAvantApprentissage,
          },
          {
            title: 'Les étapes avant d’entrer en alternance',
            component: InfographieEtapesAlternance,
          },
        ],
      },
      makeBilanActivite(DECOUVRIR_ALTERNANCE_APPRENTISSAGE_ID),
    ],
    bilanQuestions: [
      {
        id: 'definir-alternance',
        text: "Je peux définir ce qu'est l'alternance.",
      },
      {
        id: 'avantages-alternance',
        text: "Je peux citer les avantages de l'alternance.",
      },
      {
        id: 'etapes-alternance',
        text: 'Je peux citer les étapes pour entrer en alternance.',
      },
    ],
    // requirements: [hasFinishedQuestionnaire],
  },
  {
    theme: 'insertion-pro',
    moduleId: 'debattre-alternance',
    title: "Débattre sur l'alternance",
    icon: DebatIcon,
    intro: 'Ce module te permet de débattre sur l’alternance.',
    profDescription:
      'Ce module permet aux élèves de se questionner sur l’alternance à travers un débat collectif',
    objectifPedagogique: 'Déconstruire les idées reçues sur l’alternance.',
    activites: [
      {
        activiteId: 'alternance-en-debat',
        title: "L'alternance en débat",
        duration: 25,
        component: DebatAlternance,
        description: 'Avec cette activité, questionne-toi sur l’alternance.',
        profDescription:
          'Cette activité propose des questions sur l’alternance pour lever les idées reçues.',
        contentInfo: [{ type: ACTIVITE_CONTENT_TYPE_ORAL }],
      },
    ],
    // requirements: [hasFinishedQuestionnaire],
  },
  {
    theme: 'insertion-pro',
    title: 'Connaître mes compétences acquises',
    moduleId: CONNAITRE_MES_COMPETENCES_ACQUISES_ID,
    icon: CompetencesAcquisesIcon,
    intro:
      'Ce module te permettra d’identifier les compétences développées durant un stage et de savoir les exprimer.',
    profDescription:
      'Ce module permet aux lycéens d’analyser les soft skills / compétences transversales acquises durant leur stage et d’apprendre à les valoriser.',
    objectifPedagogique:
      'L’objectif est d’être capable d’identifier ses compétences développées durant un stage et de savoir en parler.',
    activites: [
      {
        title: 'Parcours inspirant',
        activiteId: 'parcours-inspirant',
        description: `
          Avec ces témoignages, tu verras que ton parcours n’est pas forcément tracé d’avance
          et que chacune de tes expériences (bonnes ou mauvaises) peuvent t’apporter quelque chose
        `,
        profDescription: `
          Deux témoignages pour ouvrir l'horizon des possibles et se dire que son parcours
          n’est pas tracé d’avance et que les élèves peuvent faire de chacune de leurs expériences une force.
      `,
        duration: 20,
        steps: [
          {
            title: 'Un parcours linéaire ?',
            component: ParcoursLineaire,
          },
          {
            title: 'Les bénéfices de l’alternance',
            component: BeneficesAlternance,
          },
        ],
        contentInfo: [
          { type: ACTIVITE_CONTENT_TYPE_VIDEO },
          { type: ACTIVITE_CONTENT_TYPE_ORAL },
        ],
      },
      {
        title: 'Mon expérience de stage',
        activiteId: 'experience-de-stage',
        duration: 25,
        description:
          "T’aider à mettre en avant tes forces et tes axes d'amélioration suite à tes stages",
        profDescription:
          'L’activité a pour but d’aider le lycéen à faire ressortir de son expérience de stage ses forces et ses axes d’amélioration.',
        contentInfo: [{ type: ACTIVITE_CONTENT_TYPE_FORM }],
        steps: [
          {
            title: 'Définition des soft skills',
            component: DefinitionSoftSkills,
          },
          {
            title: 'Experience de stage',
            component: DecrisExperienceSoftSkills,
            hasOwnFooter: true,
          },
          {
            title: 'Ressenti pendant le stage',
            component: SelectRessentiSoftSkills,
            hasOwnFooter: true,
          },
          {
            title: 'Mission de stage',
            component: DecrisActionsSoftSkills,
            hasOwnFooter: true,
          },
          {
            title: 'Les softs skills développées',
            component: SelectSoftSkills,
            hasOwnFooter: true,
          },
          {
            title: 'Les difficultés rencontrées durant le stage',
            component: SelectDifficultesSoftSkills,
            hasOwnFooter: true,
          },
          {
            title: 'Les points à améliorer',
            component: DecrisAmeliorationsSoftSkills,
            hasOwnFooter: true,
          },
          {
            title: "Recap' de mon expérience de stage",
            component: MyRecapSoftSkills,
          },
          {
            title: 'Identifier ses compétences développées en stage',
            component: IdentifierSoftSkills,
          },
        ],
      },
      {
        title: "Mon plan d'action",
        activiteId: 'mon-plan-daction',
        duration: 10,
        description:
          'Avec cette activité, les élèves réfléchissent à un objectif à atteindre et les étapes pour y arriver.',
        profDescription:
          'L’activité a pour but d’aider le lycéen à comprendre sa progression après les stages réalisés et à mieux penser son projet personnel.',
        contentInfo: [{ type: ACTIVITE_CONTENT_TYPE_FORM }],
        steps: [
          {
            title: "Plan d'action",
            component: PlanActionObjectif,
            hasOwnFooter: true,
          },
          {
            title: "Plan d'action",
            component: PlanActionTemps,
            hasOwnFooter: true,
          },
          {
            title: "Plan d'action",
            component: PlanActionEntreprendre,
            hasOwnFooter: true,
          },
          {
            title: "Recap Plan d'action",
            component: MyRecapPlanAction,
          },
        ],
      },
      makeBilanActivite(CONNAITRE_MES_COMPETENCES_ACQUISES_ID),
    ],
    bilanQuestions: [
      {
        id: 'decrire-experience-stage',
        text: 'Je peux décrire une expérience de stage que j’ai eu.',
      },
      {
        id: 'citer-competences-mobilisees-stage',
        text: 'Je peux citer des compétences mobilisées lors de ce stage.',
      },
      {
        id: 'difficultes-rencontrees-stage',
        text: 'Je peux citer des difficultés rencontrées en stage.',
      },
      {
        id: 'fixe-objectif-amelioration-stage',
        text: 'Je me suis fixé un objectif à atteindre pour m’améliorer en stage.',
      },
    ],
  },
  {
    theme: 'insertion-pro',
    moduleId: PREPARER_ENTRETIENS_ID,
    title: 'Se préparer pour ses entretiens',
    icon: MondeProIcon,
    intro: 'Cette activité te permet de préparer tes entretiens d’embauche',
    profDescription:
      'Cette activité permet de préparer des entretiens d’embauche et de mettre les élèves en situation.',
    objectifPedagogique:
      'L’objectif de ce module est de familiariser les élèves aux éléments de langage professionnel, et de comprendre l’enjeu de bien préparer un entretien d’embauche.',
    activites: [
      {
        title: "L'importance de la communication non verbale",
        activiteId: 'importance-communication-non-verbale',
        duration: 10,
        description:
          'Cette activité te permet de voir l’importance de son attitude et de sa posture lors des entretiens.',
        profDescription:
          'Cette activité permet de souligner l’importance de la communication non verbale lors des entretiens.',
        component: CommunicationNonVerbale,
        contentInfo: [{ type: ACTIVITE_CONTENT_TYPE_GAME }],
      },
      {
        title: "Simulation d'entretien",
        activiteId: "Simulation d'entretien",
        duration: 30,
        profDescription:
          'L’activité a pour but d’aider le lycéen à se préparer à ses futurs entretiens d’embauche dans le cadre de leurs recherches de stage.',
        description:
          "Cette activité te permet de te préparer pour un entretien d'embauche.",
        contentInfo: [
          { type: ACTIVITE_CONTENT_TYPE_FORM },
          { type: ACTIVITE_CONTENT_TYPE_ORAL },
        ],
        steps: [
          {
            title: 'Rappel sur les compétences',
            component: RappelCompetences,
            hasOwnFooter: true,
          },
          {
            title: 'Rappel sur les compétences',
            component: ListCompetences,
            hasOwnFooter: true,
          },
          {
            title: 'Recap compétences',
            component: MyRecapCompetences,
          },
          {
            title: 'Etape simulation entretien',
            component: SimulationEntretien,
          },
          {
            title: 'Etape simulation entretien',
            component: SimulationEntretienFeedback,
            hasOwnFooter: true,
          },
        ],
      },
      {
        title: 'Conseils pour réussir mon entretien',
        activiteId: 'conseils-pour-reussir-mon-entretien',
        duration: 10,
        description:
          "Cette activité te propose des anecdotes d'entretiens et des conseils pour réussir son entretien.",
        profDescription:
          "Cette activité propose des anecdotes d'entretiens et des conseils pour réussir son entretien.",
        contentInfo: [
          { type: ACTIVITE_CONTENT_TYPE_VIDEO },
          { type: ACTIVITE_CONTENT_TYPE_ORAL },
        ],
        steps: [
          {
            title: 'Témoignage anecdotes',
            component: TemoignagesAnecdotes,
          },
          {
            title: 'Témoignages Professionnels RH',
            component: TémoignagesProRH,
          },
          {
            title: 'Infographie Conseils Entretien Embauche',
            component: InfographieConseilEntretien,
          },
        ],
      },
      makeBilanActivite(PREPARER_ENTRETIENS_ID),
    ],
    bilanQuestions: [
      {
        id: 'definir-communication-non-verbale',
        text: 'Je peux définir la communication non-verbale.',
      },
      {
        id: 'infos-importantes-preparer-entretien',
        text: "Je peux citer les informations importantes à préparer avant d'aller en entretien.",
      },
      {
        id: 'capable-adopter-comportement-pro',
        text: "Je me sens capable d'adopter un comportement professionnel en entretien.",
      },
    ],
    // requirements: [hasFinishedQuestionnaire],
  },
  {
    theme: 'insertion-pro',
    moduleId: RECHERCHER_STAGE_POSTULER_ID,
    title: 'Rechercher son stage et postuler',
    icon: RechercheStageIcon,
    intro:
      "L'objectif de ce module est de t’aider à savoir comment rechercher une offre de stage sur Internet ainsi qu’y répondre avec la rédaction d’un CV et d’une LM.",
    profDescription:
      'Ce module a pour objectif d’aider le lycéen à savoir comment chercher une offre de stage sur Internet et savoir y répondre avec l’élaboration d’un CV et d’une lettre de motivation.',
    objectifPedagogique:
      'Avec ce module, les lycéens seront en capacité d’initier une recherche de stage sur Internet et d’y postuler.',
    activites: [
      {
        title: 'Je recherche mon stage sur Internet',
        activiteId: 'recherche-stage-sur-internet',
        duration: 20,
        description:
          'En regardant une vidéo, tu découvriras comment faire une recherche de stage sur Internet.',
        profDescription:
          'À travers une vidéo, cette activité propose une méthode de recherche de stage sur Internet.',
        contentInfo: [
          { type: ACTIVITE_CONTENT_TYPE_VIDEO },
          { type: ACTIVITE_CONTENT_TYPE_FORM },
        ],
        steps: [
          {
            title: 'Faire une recherche de stage efficace sur Internet',
            component: VideoRechercheDeStage,
          },
          {
            title: 'Questions Rechercher son stage sur Internet',
            component: QuestionsRechercheDeStage,
            hasOwnFooter: true,
          },
          {
            title: 'Préparer sa recherche de stage',
            component: PreparerRechercheDeStage,
          },
          {
            title: 'QCM',
            component: QCMRechercheDeStage,
          },
        ],
      },
      {
        title: 'Conseils pour mon CV',
        activiteId: 'conseils-cv',
        description:
          'Cette activité te permet de tester tes connaissances sur la rédaction d’un CV et d’avoir quelques conseils. ',
        profDescription:
          'Cette activité permet aux élèves de tester leurs connaissances sur la rédaction d’un CV et d’avoir quelques conseils.',
        contentInfo: [{ type: ACTIVITE_CONTENT_TYPE_FORM }],
        duration: 15,
        steps: [
          { title: 'Quiz sur le CV', component: QuizzCV },
          {
            title: 'Checklist : CV',
            component: ChecklistCV,
            hasOwnFooter: true,
          },
        ],
      },
      {
        title: 'Conseils pour ma lettre de motivation',
        activiteId: 'conseils-lettre-motivation',
        description:
          'cette activité te permet de tester tes connaissances sur la rédaction d’une lettre de motivation et d’avoir quelques conseils.',
        profDescription:
          'Cette activité permet aux élèves de tester leurs connaissances sur la rédaction d’une lettre de motivation et d’avoir quelques conseils.',
        contentInfo: [{ type: ACTIVITE_CONTENT_TYPE_FORM }],
        duration: 15,
        steps: [
          { title: 'Quiz sur la lettre de motivation', component: QuizzLM },
          {
            title: 'Checklist : Lettre de motivation',
            component: ChecklistLM,
            hasOwnFooter: true,
          },
        ],
      },
      makeBilanActivite(RECHERCHER_STAGE_POSTULER_ID),
    ],
    bilanQuestions: [
      {
        id: 'capable-recherche-stage-internet',
        text: 'Je me sens capable de faire une recherche de stage sur internet.',
      },
      {
        id: 'capable-faire-cv',
        text: 'Je me sens capable de faire un CV.',
      },
      {
        id: 'capable-faire-lm',
        text: 'Je me sens capable de faire une lettre de motivation.',
      },
    ],
  },
];

export default modules;
